// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__MLtM1"};